export class AlertConfig<D = any> {
    data?: D;
    id?: number;
    target?: string;
}
